/**
 * useHeaderSearch — Reads ?q from URL (set by Header search).
 * Returns a filter function that checks if any of the given fields match.
 * Use this in pages with custom layouts (StatusSidebar) that don't use ListPageShell.
 */
import { useRouterState } from '@tanstack/react-router';

export function useHeaderSearch() {
    const urlQ: string = (useRouterState({ select: (s) => s.location.search }) as Record<string, any>)?.q || '';
    return {
        /** Current header search query (from URL ?q) */
        headerSearch: urlQ,
        /** Filter an array by matching searchFields against ?q */
        filterBySearch<T extends Record<string, any>>(items: T[], searchFields: (keyof T | string)[]): T[] {
            if (!urlQ.trim()) return items;
            const q = urlQ.toLowerCase();
            return items.filter(item =>
                searchFields.some(field => {
                    const parts = String(field).split('.');
                    let val: any = item;
                    for (const p of parts) val = val?.[p];
                    return String(val ?? '').toLowerCase().includes(q);
                })
            );
        },
    };
}
